import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { IEquipmentRequest } from './dto/Request.dto';

/**
 * Получение информации об оборудовании
 */
export const equipment = <TCategory>({ providerId, globalId, categories, routerFilter }: IEquipmentRequest<TCategory>): IRequest => ({
    uri: `/v1/${providerId}/equipment`,
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams: {
        globalId,
        categories,
        routerFilter,
    },
});
